import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2, ExternalLink } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { clearSelectedGuest } from "@/store/altingross/guests";

export default function GuestDetailModal({ open, onOpenChange }) {
  const dispatch = useDispatch();
  const { selectedGuest, detailLoading } = useSelector((s) => s.guests);

  const handleClose = () => {
    onOpenChange(false);
    dispatch(clearSelectedGuest());
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) handleClose(); }}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Misafir Detayları</DialogTitle>
          <DialogDescription>
            Misafire ait tarayıcı ve oturum bilgileri.
          </DialogDescription>
        </DialogHeader>
        <div className="pt-2">
          {detailLoading ? (
            <div className="flex justify-center py-8">
              <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
            </div>
          ) : selectedGuest ? (
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div className="flex flex-col">
                <span className="text-gray-500 font-semibold text-xs">IP Adresi</span>
                <span>{selectedGuest.ipAddress || "-"}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-gray-500 font-semibold text-xs">Durum</span>
                <span>{selectedGuest.isBot ? "Bot" : "Gerçek Kullanıcı"}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-gray-500 font-semibold text-xs">Cihaz / İşletim Sistemi</span>
                <span>{selectedGuest.deviceType} / {selectedGuest.os}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-gray-500 font-semibold text-xs">Ziyaret Tarihi</span>
                <span>{selectedGuest.visitedAt ? new Date(selectedGuest.visitedAt).toLocaleString("tr-TR") : "-"}</span>
              </div>
              <div className="flex flex-col col-span-2">
                <span className="text-gray-500 font-semibold text-xs">Tarayıcı</span>
                <span className="break-all">{selectedGuest.browser || "-"}</span>
              </div>
              <div className="flex flex-col col-span-2">
                <span className="text-gray-500 font-semibold text-xs">User Agent</span>
                <span className="break-all text-xs text-gray-700 bg-gray-50 p-2 rounded border border-gray-100">{selectedGuest.userAgent || "-"}</span>
              </div>
              <div className="flex flex-col col-span-2">
                <span className="text-gray-500 font-semibold text-xs">Referrer (Geldiği Yer)</span>
                <span className="break-all">{selectedGuest.referrerUrl || "-"}</span>
              </div>
              <div className="flex flex-col col-span-2">
                <span className="text-gray-500 font-semibold text-xs">İlk Girdiği Sayfa (Landing Page)</span>
                <span className="break-all">{selectedGuest.landingPage || "-"}</span>
              </div>
              <div className="flex flex-col col-span-2">
                <span className="text-gray-500 font-semibold text-xs">Konum (Enlem / Boylam)</span>
                <span>
                  {selectedGuest.latitude !== 0 || selectedGuest.longitude !== 0 ? (
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${selectedGuest.latitude},${selectedGuest.longitude}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline flex items-center gap-1"
                    >
                      {selectedGuest.latitude}, {selectedGuest.longitude}
                      <ExternalLink className="w-3 h-3" />
                    </a>
                  ) : (
                    "-"
                  )}
                </span>
              </div>
              <div className="flex flex-col col-span-2 mt-2">
                <span className="text-gray-500 font-semibold text-xs mb-2">Çerez İzinleri</span>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-2 rounded border border-gray-100">
                    <span className="text-[10px] uppercase text-gray-500 font-semibold mb-1">Zorunlu</span>
                    <span className={`text-xs font-bold ${selectedGuest.isUseNecessary ? "text-green-600" : "text-red-500"}`}>
                      {selectedGuest.isUseNecessary ? "Onaylı" : "Reddedildi"}
                    </span>
                  </div>
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-2 rounded border border-gray-100">
                    <span className="text-[10px] uppercase text-gray-500 font-semibold mb-1">Analitik</span>
                    <span className={`text-xs font-bold ${selectedGuest.isUseAnalytics ? "text-green-600" : "text-red-500"}`}>
                      {selectedGuest.isUseAnalytics ? "Onaylı" : "Reddedildi"}
                    </span>
                  </div>
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-2 rounded border border-gray-100">
                    <span className="text-[10px] uppercase text-gray-500 font-semibold mb-1">Pazarlama</span>
                    <span className={`text-xs font-bold ${selectedGuest.isUseMarketing ? "text-green-600" : "text-red-500"}`}>
                      {selectedGuest.isUseMarketing ? "Onaylı" : "Reddedildi"}
                    </span>
                  </div>
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-2 rounded border border-gray-100">
                    <span className="text-[10px] uppercase text-gray-500 font-semibold mb-1">İşlevsel</span>
                    <span className={`text-xs font-bold ${selectedGuest.isUseFunctional ? "text-green-600" : "text-red-500"}`}>
                      {selectedGuest.isUseFunctional ? "Onaylı" : "Reddedildi"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center text-gray-500 py-4">Kayıt bulunamadı.</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
